import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

// Pathname → i18n key. First match wins, so order matters.
const TITLE_PATTERNS: Array<[RegExp, string]> = [
  [/^\/$/, "home"],
  [/^\/home/, "navigation.dashboard"],
  [/^\/orders/, "navigation.orders"],
  [/^\/products/, "navigation.products"],
  [/^\/partners/, "navigation.partners"],
  [/^\/chat/, "navigation.chat"],
  [/^\/recap_transport/, "navigation.recap_transport"],
  [/^\/recap/, "navigation.recap"],
  [/^\/daily_recap/, "navigation.recap"],
  [/^\/stocks/, "navigation.stocks"],
  [/^\/purchases/, "navigation.purchases"],
  [/^\/flows/, "navigation.flows"],
  [/^\/lots/, "navigation.lots"],
  [/^\/client-groups/, "clientGroups.title"],
  [/^\/operations/, "navigation.operations"],
  [/^\/steering/, "navigation.businessIntelligence"],
  [/^\/reports/, "navigation.reports"],
  [/^\/workflows/, "navigation.workflows"],
  [/^\/ai-proposals/, "aiProposals.title"],
  [/^\/ai-pre-orders/, "aiProposals.title"],
  [/^\/ai/, "navigation.aiManagement"],
  [/^\/agent-logs/, "agentLogs.title"],
  [/^\/pricing/, "navigation.pricing"],
  [/^\/parameters/, "navigation.parameters"],
  [/^\/preferences/, "preferences.title"],
  [/^\/profile/, "navigation.profile"],
  [/^\/contacts/, "navigation.contacts"],
  [/^\/saved-offers/, "navigation.savedOffers"],
  [/^\/routes/, "routes.title"],
  [/^\/emails/, "navigation.messages"],
  [/^\/units/, "navigation.inventory"],
  [/^\/message-settings/, "messageSettings.title"],
  [/^\/company/, "company.title"],
  [/^\/crm/, "navigation.contacts"],
  [/^\/product-crm/, "navigation.contacts"],
  [/^\/ressere/, "ressere.title"],
  [/^\/seeding/, "seeding.title"],
  [/^\/impersonate/, "superadmin.impersonate"],
  [/^\/superadmin/, "superadmin.title"],
  [/^\/login/, "auth.login"],
  [/^\/signup/, "auth.signupLink"],
  [/^\/forgot-password/, "auth.forgotPassword"],
];

const BRAND = "Stockline";

export function usePageTitle() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const match = TITLE_PATTERNS.find(([re]) => re.test(pathname));
    if (!match) {
      document.title = BRAND;
      return;
    }
    const key = match[1];
    const translated = t(key);
    // If translation missing, t() returns the key — fall back to brand only.
    const label = translated && translated !== key ? translated : null;
    document.title = label ? `${BRAND} — ${label}` : BRAND;
  }, [pathname, t, i18n.language]);
}
